const settings = {
  domainTail: process.env.VUE_APP_DOMAIN_TAIL,
  staticFileUrl: process.env.VUE_APP_IMAGE_PORTAL,
  staticBaseUrl: process.env.VUE_APP_UPLOAD_IMAGE_PORTAL,
  ossFileUrl: process.env.VUE_APP_OSS_FILE_URL,
};

export default settings;
